import React, { Component } from 'react';
import { Button, Row, Col } from 'antd';
import Granim from 'granim';
import logo from '../assets/img/ll-icon.svg';
import './App.css';

class App extends Component {

    componentDidMount() {
        var gradient = new Granim({
            element: '#canvas',
            direction: 'diagonal',
            opacity: [1, 1],
            states : {
                "default-state": {
                    gradients: [
                        ['#AA076B', '#61045F'],
                        ['#02AAB0', '#00CDAC'],
                        ['#DA22FF', '#9733EE']
                    ]
                }
            }
        });
    }

    render() {
        return (
            <div>
                <canvas id="canvas"></canvas>
                <div className="App">
                    <div className="Wrapper Hero">
                        <Row type="flex" justify="center" align="middle" className="Wrapper">
                            <Col xs={24}>
                                <div className="u-flex-center-column">
                                    <img className="Hero-logo" src={ logo } />
                                    <h1 className="u-text-title u-text-reverse u-text-italic">
                                       Light Layer
                                    </h1>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="Banner">
                    Coming Soon
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js